<template>
	<v-header title="确认订单" headerLeftStatus="true" />
	<div class="sysMain">
		<div class="sysMainBody">
			<div style="height: 100%;padding-bottom: 30px;">
				<Card style="width:100%; margin-bottom:10px;" v-for="(item,index) in suiteList" >
					<template #title>
						{{item.SuiteName}}
					</template>
					<template #extra>
						<Text type="danger">
							<Numeral :value="item.UnitPrice" format="0,0.00">
								<template #prefix>
									<strong>¥</strong>
								</template>
							</Numeral>
						</Text>
					</template>
					<Form :ref="'form'+index"  :model="item" :rules="ruleValidate" :label-width="80">
						<FormItem label="描述">
							<Row>
								<Col flex="auto" style="color: #8C8C8C; ">{{item.Describe}}</Col>
								<Col flex="60px"><Button @click="showDrawerUser(index)">选择</Button></Col>
							</Row>
						</FormItem>
						<FormItem label="姓名" prop="PatientName">
							<Input v-model="item.PatientName" placeholder="请输入"></Input>
						</FormItem>
						<FormItem label="证件类型" prop="IDCardType">
							<Select v-model="item.IDCardType">
								<Option v-for="cardType in view.iDCardType" :value="cardType.value" :key="cardType.value">{{ cardType.value }}
								</Option>
							</Select>
						</FormItem>
						<FormItem label="证件号" prop="IDCardNo">
							<Input v-model="item.IDCardNo" placeholder="请输入"></Input>
						</FormItem>
						<FormItem label="电话" prop="PatientPhone">
							<Input v-model="item.PatientPhone" placeholder="请输入"></Input>
						</FormItem>
						<FormItem label="性别" prop="Sex">
							<RadioGroup v-model="item.Sex">
								<Radio label='男' style="margin-right: 50px;margin-left: 10px;">男</Radio>
								<Radio label='女'>女</Radio>
							</RadioGroup>
						</FormItem>
						<FormItem label="生日" prop="Birthday">
							<DatePicker type="date" v-model="item.Birthday" placeholder="选择体" style="width: 100%;" />
						</FormItem>
					</Form>
				</Card>
			</div>
			<div style="position: fixed;left: 0;bottom: 0;height: 40px;padding-right: 10px; background-color: white;width: 100%; ">
				<Row justify="center" align="middle">
					<Col flex="auto" style="font-weight: bold;padding-right: 5px; text-align: right; ">合计<Text
						type="danger" style="padding-right: 10px;">
						<Numeral :value="model.total" format="0,0.00">
							<template #prefix>
								<strong>¥</strong>
							</template>
						</Numeral>
					</Text></Col>
					<Col flex="70px" style="padding-left: 5px;">
					<Button type="primary" @click="confirm()">提交订单</Button>
					</Col>
				</Row>
			</div>
			<Drawer title="选择家人" placement="bottom" :mask-closable="false" height="80%"
				v-model="view.showDrawerUser">
				<List size="small" class="suiteMain">
					<ListItem v-for="item in userList">
						<ListItemMeta :title="item.patientName" @click="userCheck(item)" />
						<template #action>
							<li>
								<span>{{item.sex}}</span>
							</li>
						</template>
					</ListItem>
				</List>
			</Drawer>
		</div>
		<div style="text-align:center" v-show="suiteList.length===0">
			<Result type="warning" title="" desc="没有相关数据"></Result>
		</div>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	import {
		sysPost
	} from '@/utils/api'
	export default {
		name: 'center',
		data() {
			return {
				view: {
					iDCardType: [{
							value: '身份证'
						},
						{
							value: '工牌'
						},
						{
							value: '军官证'
						},
						{
							value: '其他证件'
						},
						{
							value: '学生证'
						},
					],
					showDrawerUser:false,
					suiteIndex:0,
				},
				userList:[],
				suiteList: [],
				model: {
					total: 0,
				},
				ruleValidate: {
					PatientName: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					IDCardType: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					IDCardNo: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					PatientPhone: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					Sex: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					Birthday: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
				}
			};
		},
		mounted() {
			this.init();
			this.user();
		},
		methods: {
			init() {
				var that = this;
				var suiteIdList = this.$route.query.suiteIdList;
				var list = this.getCart().whereEx(function(p) {
					return suiteIdList.indexOf(p.suiteId) > -1
				});
				list.eachEx(function(index, item) {
					for (var i = 0; i < item.quantity; i++) {
						that.model.total+=item.unitPrice;
						that.suiteList.push({
							SuiteId: item.suiteId, //套餐Id
							SuiteName: item.suiteName, //套餐名称
							Describe: item.describe, //套餐描述
							UnitPrice: item.unitPrice, //套餐单价
							WxUserId: "", //用户Id
							PatientName: "", //用户名
							IDCardType: "", //证件类型
							IDCardNo: "", //证件号
							PatientPhone: "", //电话
							Sex: "", //性别
							Birthday: "", //生日
						})
					}
				});
			},
			user(){
				var that=this;
				sysPost(that,{
					"url": 'Inspect/UserList',
					"data": {}
				},function(result){
					that.userList=result;
				})
			},
			showDrawerUser(index){
				this.view.showDrawerUser=true;
				this.view.suiteIndex=index;
			},
			userCheck(item){
				this.suiteList[this.view.suiteIndex].PatientName=item.patientName;
				this.suiteList[this.view.suiteIndex].IDCardType=item.idCardType;
				this.suiteList[this.view.suiteIndex].IDCardNo=item.idCardNo;
				this.suiteList[this.view.suiteIndex].PatientPhone=item.patientPhone;
				this.suiteList[this.view.suiteIndex].Sex=item.sex;
				this.suiteList[this.view.suiteIndex].Birthday=this.converterEx.toDateString(item.birthday);
				this.view.showDrawerUser=false;
			},
			confirm(){
				var that=this;
				that.suiteList.eachEx(function(index, item) {
					if(that.isNullOrEmptyEx(item.PatientName)||
					that.isNullOrEmptyEx(item.IDCardType)||
					that.isNullOrEmptyEx(item.IDCardNo)||
					that.isNullOrEmptyEx(item.PatientPhone)||
					that.isNullOrEmptyEx(item.Sex)||
					that.isNullOrEmptyEx(item.Birthday)){
						that.$Message.error('信息输入完整!');
						return false;
					}
				});
				sysPost(that, {
					"url": 'Order/Add',
					"data": {
						"ItemList": that.suiteList
					}
				}, function(result) {
					that.$Message.success('保存成功！');
					var suiteIdList = that.$route.query.suiteIdList;
					var list = that.getCart().whereEx(function(p) {
						return suiteIdList.indexOf(p.suiteId) == -1
					});
					that.setCart(list);
					that.$router.push("/orderUnPay")
				});
			}
		},
		components: {
			"v-header": header
		}
	}
</script>